import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Grid } from '@mui/material'
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { myApi } from '../../../config/axiosConfig';
import Swal from 'sweetalert2';

// COMPONENTES
import MyAutoComplete from '../../../components/inputs/MyAutoComplete';
import MyTextInput from '../../../components/inputs/MyTextInput';
import MySwitchInput from '../../../components/inputs/MySwitchInput';

const EditarIncidencia = ({ open, onClose, refresh, data }) => {

    const catalogoSeverity = [

        {value: 'LOW', label: 'LOW'},
        {value: 'MEDIUM', label: 'MEDIUM'},
        {value: 'HIGH', label: 'HIGH'},

    ]

    const [ formValues, setFormValues ] = useState({
        
        reason: '',
        severity: '',
        is_active : 1

    });

    useEffect(() => {

        if(Object.keys(data).length > 0){

            setFormValues({

                id: data.id,
                reason: data.reason,
                severity: data.severity,
                is_active: data.is_active,
    
            });

        }

    }, [data]);

    return (

        <Dialog
            open={open}
            onClose={onClose}
        >

            {/* HEADER */}

            <DialogTitle sx={{ textAlign: 'center' }}>
                Editar Incidencia
            </DialogTitle>

            {/* BODY */}

            <DialogContent>

                <Formik
                    initialValues={formValues}
                    enableReinitialize={true}
                    validationSchema={Yup.object({
                        reason: Yup.string().required('Ingresa una descripcion'),
                        severity: Yup.string().required('Selecciona una Opcion'),
                    })}
                    onSubmit={async (values, { setSubmitting, resetForm }) => {

                        try {

                            const response = await myApi.put('/reasons/update', values);

                            if(response.data){

                                setSubmitting(false);
                                resetForm();
                                onClose();
                                refresh();

                                Swal.fire({
                                    icon: 'success',
                                    title: 'Registro actualizado',
                                });

                            }

                        } catch(e) {

                            console.log(e);
                            setSubmitting(false);
                            resetForm();

                        }   

                    }}
                >
                {({ handleSubmit, values }) => (

                    <Form>

                        <Grid container spacing={2} marginTop={1}>

                            {/* MOTIVO DE RETRASO */}

                            <Grid size={12}>

                                <MyTextInput
                                    name="reason"
                                    label="Descripcion"
                                />

                            </Grid>

                            {/* SEVERITY */}

                            <Grid size={12}>

                                <MyAutoComplete
                                    name="severity"
                                    label="Severity"
                                    options={catalogoSeverity}
                                />

                            </Grid>

                            {/* ACTIVE */}

                            <Grid size={12}>

                                <MySwitchInput
                                    name="is_active"
                                    label={values.is_active === 1 ? 'Activo' : 'Inactivo'}
                                />

                            </Grid>

                            {/* FOOTER */}

                            <Grid size={12}>

                                <DialogActions
                                    sx={{ justifyContent: 'space-between' }}
                                >

                                    <Button 
                                        type="submit" 
                                        variant="contained" 
                                        color="primary"
                                        onClick={handleSubmit}
                                    >
                                        Guardar
                                    </Button>

                                    <Button onClick={onClose}>Cancelar</Button>

                                </DialogActions>

                            </Grid>

                        </Grid>

                    </Form>

                )}
                </Formik>

            </DialogContent>

        </Dialog>

    )

}

export default EditarIncidencia